import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import CustomToast from "../../../../../Components/CustomToast/CustomToast";
import LocalLogoLibrary from "../../../../../services/logoLibrary";
import {
  deleteLogoAsset,
  saveOptionById,
  updateAProjectCreditItemsState,
  updateProjectCreditItems,
  updateProjectCreditOptionsState,
} from "../../../../../Redux/actions/projectActions";
import { scheduleProjectSave } from "../../../projectSaveCoordinator";
import HeadingDisclosure from "../HeadingDisclosure";
import AlertModal from "./AlertModal";
import DeleteLogoEdit from "./DeleteEdit/DeleteLogoEdit";
import UpdateLogoEdit from "./LogoEdit/UpdateLogoEdit";
import LogoManager from "./LogoManager";
import { getLogoAssetName } from "./logoLayoutUtils";
import "./Logos.css";

export const customToatStyle = {
  position: "top-center",
  className: "Customtoastpop",
  autoClose: 3500,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  style: {
    background: "transparent",
    boxShadow: "none",
    padding: 0,
    minHeight: "auto",
    width: "auto",
  },
};

const Logos = ({
  options,
  currentBlockIdx,
  currentBlockId,
  setReLoading,
  isCard,
}) => {
  const dispatch = useDispatch();
  const [alertModal, setAlertModal] = useState(false);
  const [file, setFile] = useState({});
  const [isUploadingModal, setIsUploadingModal] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const uploadedAssetCallbackRef = useRef(null);

  const projectData = useSelector((state) => state.project?.credits);
  const projectId = useSelector((state) => state.project?._id);
  const logoLibraryRedux = useSelector(
    (state) => state?.commonReducer?.defaultLogos,
  );
  const logoLibrary =
    logoLibraryRedux && logoLibraryRedux.length > 0
      ? logoLibraryRedux
      : LocalLogoLibrary;
  const items = projectData?.[currentBlockIdx]?.items || [];

  const handleChange = (key, value) => {
    dispatch(updateProjectCreditOptionsState(currentBlockIdx, key, value));
  };

  const saveOptions = () =>
    dispatch(saveOptionById(currentBlockId, isCard));

  const updateItems = (nextItems) => {
    const snapshot = JSON.parse(JSON.stringify(nextItems));
    dispatch(updateAProjectCreditItemsState(currentBlockId, snapshot));
    return scheduleProjectSave(
      `logo-items:${projectId}:${currentBlockId}`,
      () =>
        dispatch(
          updateProjectCreditItems(currentBlockId, snapshot, {
            projectId,
            isCard,
          }),
        ),
      250,
    );
  };

  const updateLayout = (layout) => {
    handleChange("logo_layout", layout);
    saveOptions();
  };

  const handleLogoUpload = (selectedFile, onUploaded) => {
    setFile(selectedFile);
    uploadedAssetCallbackRef.current = onUploaded;
    setIsUploadingModal(true);
  };

  const handleUploadedAsset = (asset) => {
    uploadedAssetCallbackRef.current?.(asset);
    uploadedAssetCallbackRef.current = null;
  };

  const requestDeleteAsset = (logo) => {
    setDeleteTarget({
      projectId: logo.project_id,
      logoId: logo._id,
      name: getLogoAssetName(logo, "this logo"),
    });
  };

  const confirmDeleteAsset = async (projectId, logoId) => {
    const result = await dispatch(deleteLogoAsset(projectId, logoId, isCard));
    toast(
      <CustomToast
        title=""
        content={
          result?.success
            ? "Logo deleted from the library"
            : "The logo could not be deleted. Please try again."
        }
      />,
      customToatStyle,
    );
    if (result?.success) setDeleteTarget(null);
  };

  return (
    <>
      {isUploadingModal && (
        <UpdateLogoEdit
          setIsUploadingModal={setIsUploadingModal}
          file={file}
          setFile={setFile}
          setReLoading={setReLoading}
          setAlertModal={setAlertModal}
          currentBlockIdx={currentBlockIdx}
          onUploaded={handleUploadedAsset}
        />
      )}
      {alertModal && (
        <AlertModal alertModal={alertModal} setAlertModal={setAlertModal} />
      )}
      {deleteTarget && (
        <DeleteLogoEdit
          deleteEditOpen
          setDeleteEditOpen={(open) => {
            if (!open) setDeleteTarget(null);
          }}
          projectId={deleteTarget.projectId}
          logoId={deleteTarget.logoId}
          logoName={deleteTarget.name}
          deleteLogo={confirmDeleteAsset}
        />
      )}

      <div className="Roles-name">
        <div className="rolename-inside">
          <HeadingDisclosure
            heading={options?.heading || ""}
            subheading={options?.subheading || ""}
            onChange={handleChange}
            onFocusOut={saveOptions}
          />

          <LogoManager
            items={items}
            options={options || {}}
            logoLibrary={logoLibrary}
            currentBlockIdx={currentBlockIdx}
            onItemsChange={updateItems}
            onLayoutChange={updateLayout}
            onOptionChange={handleChange}
            onSaveOptions={saveOptions}
            onUploadFile={handleLogoUpload}
            onDeleteAsset={requestDeleteAsset}
            isCard={isCard}
          />
        </div>
      </div>
    </>
  );
};

export default Logos;
